export const isClickWithinClass = (target: EventTarget | null, className: string): boolean =>
  target instanceof Element && Boolean(target.closest(`.${className}`));
